import React,{useEffect,useState,useContext} from 'react';
import { Context } from '../../AppContext';
import ServiceUsers from '../../services/user';
import ServiceGeneral from '../../services/general';
const OrganisationsOverview = () => {
const [organisaties,setOrganisations] = useState([]);
  const context = useContext(Context);

    useEffect(() => {
        ServiceUsers.currentuserOrganisations()
            .then(organisations => {
                setOrganisations(ServiceGeneral.sortJSON(organisations, 'name', '123'));
              //  if (!context.organisation && organisations.length === 1) {
               //     context.setOrganisation(organisations[0]);                
              //  }
            })
    }, [])



    return (
        <div  style={{backgroundColor:'white',margin:'12px',minWidth:'260px'}}  className='padding radius-right shadow'>
            <h1>Mijn organisatie(s)</h1>
            {organisaties.map((item, index) => {
               
                return <div key={item._id} style={{cursor:'pointer'}} onClick={()=>{ context.setOrganisation(item);}}  >
                  <h3> • {item.name}</h3>
                  {item.address && <p>{item.address}<br/></p>}
                  {item.place && <p>{item.pobox && item.pobox} {item.place}</p>}
                  <br/>
                </div>

            })}
          
            <br/>
        </div>
    );
};

export default OrganisationsOverview;